import { render, staticRenderFns } from "./text-field-quarternary.vue?vue&type=template&id=30951616&scoped=true&"
import script from "./text-field-quarternary.vue?vue&type=script&lang=js&"
export * from "./text-field-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30951616",
  null
  
)

export default component.exports